import React from 'react';
const chain = ['Movements become classes.', 'Classes become structured training.', 'Training becomes progression.', 'Progression becomes long-term programming.'];
export function WhyCoaches() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-248" data-mp="39rm08tvm8hsq">
      <div className="max-w-2xl mx-auto text-center" data-id="element-249" data-mp="34tst9ymhnjre">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol mb-4" data-id="element-250" data-mp="34t0uyg1ib7xf">
          Why coaches use Fitness Senior Ready™
        </h2>

        <p className="text-[13px] sm:text-base text-petrol/70 leading-relaxed mb-2" data-id="element-251" data-mp="2w0gwpgp4n5d4">
          Because they don't need another folder filled with random workout
          ideas. And they don't need another text-heavy manual they'll have to
          study before they can use it.
        </p>

        <p className="text-[13px] sm:text-base font-semibold text-petrol leading-relaxed mb-4" data-id="element-252" data-mp="2h2oh6ojkygyx">
          They need practical resources they can see, select, adapt and coach.
        </p>

        <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em] text-petrol/50 mb-2" data-id="element-253" data-mp="3nxb2aodav1tw">
          Fitness Senior Ready™ brings the pieces together:
        </p>

        <div className="bg-white border-l-4 border-lime rounded-r-lg p-4 text-left mb-4" data-id="element-254" data-mp="3e0oi81sssesx">
          {chain.map(line => <p key={line} className="text-[13px] sm:text-base font-semibold text-petrol leading-snug" data-id="element-255" data-mp="3j014akbuhhug">
              {line}
            </p>)}
        </div>

        <p className="font-heading font-extrabold uppercase text-sm sm:text-lg tracking-tight text-green-dark" data-id="element-256" data-mp="fi0ssv72yuc3">
          Everything works together inside one visual coaching system.
        </p>
      </div>
    </section>;
}